import profile from '@/api/customer/profile'

import { baseState, baseMutations } from '@/store/mixins'
import { isEmpty } from "lodash";

export const state = {
  ...baseState,
  customerType: [],
  branch_id: [],
  location_id: [],
  sales: [],
  provinces: [],
  approve_status: null,
  sale_id: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_CUSTOMER_TYPE(state, data) {
    state.customerType = data
  },
  SET_BRANCH_ID(state, value) {
    state.branch_id = value
  },
  SET_LOCATION_ID(state, value) {
    state.location_id = value
  },
  SET_SALE(state, value) {
    state.sales = value
  },
  SET_PROVINCES(state, value) {
    state.provinces = value
  },
  SET_APPROVED_STATUS(state, value) {
    state.approve_status = value
  },
  CLEAR_STATE(state) {
    state.sales = []
    state.provinces = []
  },
  SET_SALE_ID(state, ids) {
    state.sale_id = ids
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        location_id: context.state.location_id,
        filter: {
          search: context.state.search,
          approve_status: context.state.approve_status,
          sale_id: context.state.sale_id
            ? context.state.sale_id.join(',')
            : undefined
        }
      },
      attrubutes
    )
    return profile.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return profile.store(data)
  },
  approveMulti(context, data) {
    return profile.approveMulti(data)
  },
  update(context, { id, data }) {
    return profile.update(id, data)
  },
  async find(context, id) {
    if (isEmpty(context.state.edit_data)) {
      let response = await profile.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id) {
    return profile.destroy(id)
  },
  getFormViewModel(context, attributes = {}) {
    return profile.formViewModel({ params: attributes })
  },
  customerExportExcel(context, { ...attributes }) {
    return profile.customerExportExcel(
      Object.assign(
        {
          template: localStorage.getItem('langCode')
            ? localStorage.getItem('langCode')
            : 'en'
        },
        {
          branch_id: context.state.branch_id,
          location_id: context.state.location_id
        },
        attributes
      )
    )
  }
}
